

import axios, { AxiosResponse } from 'axios';

import jsCookie from 'js-cookie';
import { get } from 'lodash-es';
import toast from 'react-hot-toast';
import { authUrl } from '../env';
import { resetUserInfo } from '../logger/bd-tracker';

const logout = () => {
  jsCookie.remove('token');
  resetUserInfo();

  const org = jsCookie.get('org');
  const p = org ? 'org' : '';
  const s = org ? `org=${org}&` : '';
  const loginUrl = `${authUrl}${p}?${s}redirect_uri=${btoa(window.location.href)}`;
  console.log('[Org]', org, loginUrl);
  window.location.replace(loginUrl);
};

const API_WHITE_LIST = ['/api/student/get-operation-permissions-list'];

const checkIsTourist = (data: any) => {
  return get(data, 'header[\'x-user-role\']') === 'tourist';
};

axios.interceptors.request.use(
  function (config) {
    const token = jsCookie.get('token');
    if (config.headers['X-Homework-Session']) { delete config.headers.Authorization; return config; }
    config.headers.Authorization = config?.headers?.Authorization ?? (token || '');
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

function notAuthHandler(code: number) {
  // 401 目前代表未登录
  // 3020 表示账号失效
  if (code === 401 || code === 3020) {
    // 如果是首页, 且有 token, 说明是登录态失效，需要跳转到登录页
    console.error('当前用户无权限');
    logout();
  }
}


// 拦截器1: 重新组织数据结构，非 200 状态码走后续异常逻辑
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    const { code, message: errorMessage, statusCode, } = response.data;
    if (code === 200 || statusCode === 200) {
      return {
        ...response.data,
        header: response.headers
      };
    }
    if (code !== 200) {
      return Promise.reject({ ...response.data, error: errorMessage, header: response.headers, config: response.config });
    }
  },
  function (error) {
    // Cancellation must settle callers too, otherwise draft-save thunks keep
    // their in-flight lock forever after the submission timeout aborts them.
    return Promise.reject(error);
  }
);

// 拦截器2: 权限拦截
axios.interceptors.response.use(
  function (response: AxiosResponse) {

    return response;
  },
  function (error) {
    const { code } = error as any;
    if (code === 3001 && !API_WHITE_LIST.includes(error.config.url)) {
      console.error('当前用户无权限');
      if (checkIsTourist(error)) {
        toast.error('你当前没有登录');
        logout();
      } else {
        toast.error('你当前没有权限，请退出购买');
      }
      return Promise.reject(error);
    }
    if (!error.config?.headers?.['X-Homework-Session']) notAuthHandler(code);
    return Promise.reject(error);
  }
);

// 3 写作超长后拦截
axios.interceptors.response.use(
  function (response: AxiosResponse) {

    return response;
  },
  function (error) {
    const { code } = error as any;
    try {
      if (code === 'ERR_BAD_RESPONSE' && error.response.status === 500 && error.response.data.msg.includes('Data too long for column')) {
        toast.error('文章太长了，请精简一下你的表达', { duration: 12000, style: { marginTop: '4rem' }, id: 'writing-length' });
      }
    } catch (e) {
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return Promise.reject(error);
    }
  }
);
